/**
 * @generated SignedSource<<20a0c79ac9d5d83efc27a16adcba6f0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Stripe__CancelSubscriptionPayload",
    "kind": "LinkedField",
    "name": "stripeCancelSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StripeCancelSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StripeCancelSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ac38af3178a98948486691e77df3506",
    "id": null,
    "metadata": {},
    "name": "StripeCancelSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation StripeCancelSubscriptionMutation(\n  $input: Stripe__CancelSubscriptionInput!\n) {\n  stripeCancelSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

node.hash = "b47d465bad56bfaf630a3f9542ab4955";

module.exports = node;
